module.exports = __webpack_public_path__ + "media/images/japan/big-full-price-c635990f0adeacc813f3a8eee5d52d2b.png";